import React, { useState } from 'react'
import { ReactComponent as ChevronDown } from '../../../assets/media/icons/chevron-down.svg'
import styles from './FiltersRadio.module.scss'
import PropTypes from 'prop-types'

const FiltersRadio = ({ title, selectedFilter, onFilterSelect, filters }) => {
    const [isOpen, setIsOpen] = useState(false)
    const contentId = `filter-content-${title.replace(/\s+/g, '-').toLowerCase()}`

    const handleToggle = () => {
        setIsOpen(!isOpen)
    }

    const handleKeyDown = e => {
        // Allow Enter or Space to toggle accordion
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleToggle()
        }
    }

    return (
        <div className={styles.category}>
            <button
                className={styles.category_header}
                onClick={handleToggle}
                onKeyDown={handleKeyDown}
                aria-expanded={isOpen}
                aria-controls={contentId}
                type='button'
            >
                <h6 className={styles.category_heading}>{title}</h6>
                <ChevronDown className={`${styles.category_icon} ${isOpen ? styles.open : ''}`} aria-hidden='true' />
            </button>
            {filters?.length > 0 && (
                <div
                    id={contentId}
                    className={`${styles.category_filter} ${isOpen ? styles.open : ''}`}
                    role='region'
                    aria-labelledby={contentId}
                >
                    {filters?.map(f => {
                        return (
                            <div key={f.value} className={styles.category_filterItem}>
                                <input
                                    type='radio'
                                    className={styles.category_filterItem_checkbox}
                                    name={title}
                                    id={f.value}
                                    value={f.value}
                                    checked={selectedFilter === f.title}
                                    onChange={() => onFilterSelect(f)}
                                    tabIndex={isOpen ? 0 : -1}
                                />
                                <label htmlFor={f.value}>{f.groupName || f.displayName || f.title}</label>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

FiltersRadio.propTypes = {
    title: PropTypes.string,
    filters: PropTypes.array,
    selectedFilter: PropTypes.string,
    onFilterSelect: PropTypes.func,
}

export default FiltersRadio
